import { render, staticRenderFns } from "./VehicleModelFilterComponent.vue?vue&type=template&id=bf68f54e"
import script from "./VehicleModelFilterComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleModelFilterComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports